import React from "react";
import { Loader } from "@common/loader";

import { Modal } from "@common/modal";
import { Props, Node as N } from "./types";
import { extractZip } from "./utils";
import { Nodes } from "./nodes";
import styles from "./styles.scss";

function ZipRenderer({ document, file, close }: Props) {
  const [{ unZippedFile, isPending }, setState] = React.useState<{
    unZippedFile: N;
    isPending: boolean;
  }>({
    unZippedFile: {
      type: "folder",
      name: "/",
      children: [],
      mimeType: "",
    },
    isPending: false,
  });

  React.useEffect(() => {
    setState((state) => ({ ...state, isPending: true }));

    extractZip(file).then((unZippedFile) =>
      setState({ unZippedFile, isPending: false }),
    );
  }, [file.uri]);

  return (
    <div className={styles.renderer}>
      <Modal close={close} header={document.name}>
        {isPending ? <Loader /> : <Nodes node={unZippedFile} />}
      </Modal>
    </div>
  );
}

export { ZipRenderer };
